import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('student');

export class Student extends Api {
  constructor(http, config = {}) {
    super(http, url, 'student', config);
  }
  
  async updateStudentProcessing(studentProcessingId, requestBody, config = {}) {
    config = { ...this._config, ...config };

    return this._http.put(`${this._baseUrl}/${studentProcessingId}/status`, requestBody, config);
  }

  async getELibroLink(email, config = {}){
    config = { ...this._config, ...config };

    return this._http.get(`${this._baseUrl}/e-book?mail=${email}`, {}, config);
  }

  async getRequest(config = {}){
    config = { ...this._config, ...config };

    return this._http.get(`${this._baseUrl}/request`, {}, config);
  }

  async getStudentRequest(id) {
    return this._http.get(`${this._baseUrl}/student/${id}/request`);
  }

  async getTitlesByStTitleId(titleId) {
    return this._http.get(`${this._baseUrl}/student/title/${titleId}`);
  }

  async downloadTitle(titleId, config = {}) {
    config = { ...this._config, ...config };

    return this._http.get(`${this._baseUrl}/student/title/${titleId}/download`, {}, config);
  }

  async generateStudentTitle(studentTitleId, config = {}) {
    config = { ...this._config, ...config };

    return this._http.get(`${this._baseUrl}/student/title/${studentTitleId}/generate`, {}, config);
  }
  
  async generateStudentTitleSimulate(studentTitleId, config = {}) {
    config = { ...this._config, ...config };

    return this._http.get(`${this._baseUrl}/student/title/${studentTitleId}/generate/simulate`, config);
  }

  async createStudentRequest(studentCareerId, requestBody, config = {}) {
    config = { ...this._config, ...config };
  
    return this._http.put(`${this._baseUrl}/student/studentCareer/${studentCareerId}/request`, requestBody, config);
  }

  async getAllStudentTitles() {
    return this._http.get(`${this._baseUrl}/student/title`);
  }

  async createStudentTitle(requestBody, config = {}) {
    config = { ...this._config, ...config };

    return this._http.post(`${this._baseUrl}/student/title`, requestBody, config);
  }

  async updateStudentTitle(requestBody, config = {}) {
    config = { ...this._config, ...config };

    return this._http.put(`${this._baseUrl}/student/title`, requestBody, config);
  }

  async getStudentRecord(studentRecordId) {

    return this._http.get(`${this._baseUrl}/students/${studentRecordId}`);
  }

  async getTitlesBySR(studentRecord) {
    return this._http.get(`${this._baseUrl}/student/${studentRecord}/title`);
  }

  async changeStudentCareerValidity(requestBody, config = {}) {
    config = { ...this._config, ...config };

    return this._http.post(`${this._baseUrl}/student-career/change-validity`, requestBody, config);
  }

  async updateSubscriptionStatus(requestBody, config = {}) {
    config = { ...this._config, ...config };
    return this._http.put(`${this._baseUrl}/subscription/status`, requestBody, config);
  }
}